export default (
  settings = {
    open: null,
    current: null,
    previous: null,
  }
) => ({
  ...settings,
  // timeout: null,

  handleClick(idx) {
    if (this.current === idx) {
      this.current = null;
      setTimeout(() => {
        this.open = null;
        this.previous = null;
      }, 250);
      return;
    }

    if (!this.current) {
      this.open = idx;
      this.current = idx;
      this.previous = idx;
      return;
    }

    this.current = idx;
    this.open = idx;
    setTimeout(() => {
      this.previous = idx;
    }, 250);
  },
});
